import { CardModalContent } from '@anm/components/modals/CardModal';
import Invite from '@anm/components/stream/Invite';
import { media } from '@anm/styles/helpers';
import { memo, FC } from 'react';
import styled from 'styled-components';

import { ModalWrapper } from '../StreamModalWrapper';

type InviteGuestsModalProps = {
  link?: string;
  title?: string;
  maxGuests?: number;
  descriptionStart?: string;
  isMaxSubscription?: boolean;
  onClose: () => void;
};

const mobileCardWrapper = media.phone`
  min-width: unset;
`;

export const Wrapper = styled(ModalWrapper)`
  ${CardModalContent} {
    min-width: 500px;
    ${mobileCardWrapper};
  }
`;

const InviteGuestsModal: FC<InviteGuestsModalProps> = ({ link, onClose, ...rest }) => (
  <Wrapper onModalClose={onClose}>
    <Invite {...rest} link={link?.split('?skipSetup')[0]} />
  </Wrapper>
);

export default memo(InviteGuestsModal);
